"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var core_1 = require("@athena-portal/core");
var react_router_dom_1 = require("react-router-dom");
var PageNotFound = function () { return (React.createElement("div", null,
    React.createElement("div", null, "404"))); };
var Body = /** @class */ (function (_super) {
    __extends(Body, _super);
    function Body(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            routes: _this.routesManager.getRoutes(),
            loggedIn: false
        };
        return _this;
    }
    Body.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(react_router_dom_1.Switch, null,
                this.state.routes.map(function (route) { return React.createElement(react_router_dom_1.Route, { exact: route.exact, key: route.path, path: route.path, 
                    // tslint:disable-next-line:jsx-no-lambda
                    render: function (props) { return React.createElement(route.component, props); } }); }),
                React.createElement(react_router_dom_1.Route, { exact: true, path: "/404", component: PageNotFound }))));
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.RoutesManager),
        __metadata("design:type", Object)
    ], Body.prototype, "routesManager", void 0);
    return Body;
}(React.Component));
exports.default = Body;
//# sourceMappingURL=Body.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/Body.js
// module id = 2127
// module chunks = 0